import React, { useEffect, useMemo, useState } from "react";
import { Breadcrumb, Button, Col, Form, Row, Select, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import styles from "./coChangeSimStatus.module.scss";
import Profile from "../profile/profile";
import { useAPIPublic, useDealer, useReport } from "../../../../tools/api";

const ALLOWED_VALUES = [1, 102]; // فقط "فعال" و "قطع دو طرفه"

const CoChangeSimStatus = () => {
	const [t] = useTranslation("global");
	const nav = useNavigate();
	const [frmService] = Form.useForm();
	const location = useLocation();

	const { _currentUser } = useSelector((state) => state?.another || {});

	const { queryMSISDNStatus } = useAPIPublic();
	const { querySPPurchaseDealerByMSISDN } = useReport();
	const { changeMSISDNStatus } = useDealer();

	const [changeStatus, setChangeStatus] = useState({
		isLoading: true,
		purchase: location?.state || {},
		status: [],
		isSuccessfull: false,
		msisdnStatusTypeDescription: "",
		msisdnStatusTypeId: null,
	});

	// Modal state (result)
	const [resultOpen, setResultOpen] = useState(false);
	const [resultCurrent, setResultCurrent] = useState("فعال");
	const [resultTarget, setResultTarget] = useState("-");
	const [resultMsisdn, setResultMsisdn] = useState(undefined);

	const getLabelByValue = (val) => {
		const all = changeStatus.status || [];
		const item = all.find((s) => Number(s.value) === Number(val));
		return item?.name ?? String(val);
	};

	// فقط گزینه‌های مجاز، و اگر وضعیت فعلی 1 یا 102 باشد، فقط گزینهٔ مخالف را نشان بده
	const allowedStatusList = useMemo(() => {
		const base = (changeStatus.status || []).filter((s) => ALLOWED_VALUES.includes(Number(s.value)));
		const cur = Number(changeStatus.msisdnStatusTypeId);
		if (cur === 1) return base.filter((s) => Number(s.value) === 102);
		if (cur === 102) return base.filter((s) => Number(s.value) === 1);
		return base; // برای سایر وضعیت‌ها، هر دو گزینه 1 و 102 را نشان بده
	}, [changeStatus.status, changeStatus.msisdnStatusTypeId]);

	useEffect(() => {
		const callServices = async () => {
			if (!location.state) return;

			setChangeStatus((prv) => ({ ...prv, isLoading: true }));

			const res = await queryMSISDNStatus();
			if (!res) {
				setChangeStatus((prv) => ({ ...prv, isLoading: false }));
				return;
			}
			setChangeStatus((up) => ({ ...up, status: res }));

			const resStatus = await querySPPurchaseDealerByMSISDN({
				sort: "",
				filter: (changeStatus.purchase || {}).inT_MSISDN,
				entriesperpage: 10,
				page: 0,
				totalrowcount: 0,
			});

			if (resStatus && resStatus.Result?.length > 0) {
				const cur = resStatus.Result[0];
				const curId = Number(cur?.msisdnStatusTypeId);

				setChangeStatus((up) => ({
					...up,
					isSuccessfull: true,
					msisdnStatusTypeDescription: cur?.msisdnStatusTypeDescription || "",
					msisdnStatusTypeId: isNaN(curId) ? null : curId,
					isLoading: false,
				}));
			} else {
				setChangeStatus((up) => ({ ...up, isLoading: false }));
			}
		};
		callServices();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// وقتی وضعیت فعلی یا لیست آپدیت شد، مقدار اولیه Select را روی تنها گزینهٔ موجود بگذار
	useEffect(() => {
		if (!changeStatus.isLoading) {
			const nextDefault = allowedStatusList[0]?.value;
			frmService.setFieldsValue({
				status: nextDefault != null ? Number(nextDefault) : undefined,
			});
		}
	}, [changeStatus.isLoading, allowedStatusList, frmService]);

	const handleSubmit = async (value) => {
		setChangeStatus((up) => ({ ...up, isLoading: true }));

		const payload = {
			msisdn: changeStatus.purchase.inT_MSISDN,
			description: "string",
			status: Number(value?.status),
			planid: 0,
		};

		const response = await changeMSISDNStatus(payload);

		if (response) {
			const targetLabel = getLabelByValue(Number(value?.status));
			setResultMsisdn(changeStatus?.purchase?.inT_MSISDN);
			setResultCurrent(changeStatus.msisdnStatusTypeDescription || "فعال");
			setResultTarget(targetLabel || String(value?.status));
			setResultOpen(true);
		}

		setChangeStatus((up) => ({ ...up, isLoading: false }));
	};

	// دکمه فقط وقتی غیرفعال است که در حال لود باشیم یا گزینه‌ای برای انتخاب وجود نداشته باشد
	const selectedStatus = Form.useWatch("status", frmService);
	const isSubmitDisabled = changeStatus.isLoading || allowedStatusList.length === 0 || selectedStatus == null;

	return (
		<>
			<div className={`container-main ${styles.container_list}`}>
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("corporateSearch.title") }]}
					/>
					<div className="title-page">
						<h3>{t("corporateSearch.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className={`g-layout-main ${styles.list_container} `}>
						<div className="g-format-page">
							<div className="g-body-format-page">
								<Profile Profile={changeStatus?.purchase} />
								{changeStatus?.purchase && (
									<>
										<div className={styles.container_update_network}>
											<div className={styles.container_update_network}>
												<Form id="frmService" name="frmService" layout="vertical" form={frmService} onFinish={handleSubmit}>
													<Row>
														<Col span={8} xl={8} lg={12} md={15} xs={24} sm={24}>
															<Form.Item
																className="input-normal"
																name="status"
																label="وضعیت جدید سیم کارت"
																extra={
																	changeStatus.isSuccessfull &&
																	changeStatus.msisdnStatusTypeDescription && (
																		<span style={{ color: "#37B399" }}>
																			{" "}
																			وضعیت سیم کارت شما در حال حاضر ({changeStatus.msisdnStatusTypeDescription}) می‌باشد{" "}
																		</span>
																	)
																}
																rules={[{ required: true, message: "وضعیت را انتخاب کنید" }]}>
																<Select
																	placeholder="انتخاب وضعیت"
																	loading={changeStatus.isLoading}
																	optionFilterProp="children"
																	showSearch
																	options={allowedStatusList.map((item) => ({
																		label: item.name,
																		value: Number(item.value),
																	}))}
																/>
															</Form.Item>
														</Col>
														<Col span={4} xl={4} lg={6} md={15} xs={24} sm={24}>
															<br />
															<div className="holder-button">
																<Button className="btn-normal btn-green" htmlType="submit" disabled={isSubmitDisabled}>
																	ثبت
																</Button>
															</div>
														</Col>
													</Row>
												</Form>
											</div>
										</div>
									</>
								)}
							</div>
						</div>

						{/* Result modal */}
						<Modal
							open={resultOpen}
							onCancel={() => setResultOpen(false)}
							footer={
								<Button
									className={styles.btn_result_confirm}
									type="primary"
									onClick={() => {
										setResultOpen(false);
										nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.Search);
									}}
									block>
									تایید
								</Button>
							}
							centered
							width={420}
							title={null}
							rootClassName={styles.result_modal_root}>
							<div className={styles.result_wrap}>
								<div className={styles.result_title}>تغییر وضعیت سیم کارت</div>
								<div className={styles.result_text}>
									وضعیت سیم کارت {resultMsisdn ? `«${resultMsisdn}»` : "موردنظر"} از
									<strong> «{resultCurrent}» </strong>
									به
									<strong> «{resultTarget}» </strong>
									تغییر یافت.
								</div>
							</div>
						</Modal>
					</Content>
				</div>
			</div>
		</>
	);
};

export default CoChangeSimStatus;
